import React from 'react';
import { IIconProps } from './utils';

export const GeoCompass = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C20.1258 2.5 24.531 5.58524 26.4599 10M17.2957 17.2957C16.9614 17.6301 16.5638 17.9012 16.1213 18.0909L10.1862 20.6345C9.66759 20.8567 9.14325 20.3324 9.3655 19.8138L11.9091 13.8787C12.0988 13.4362 12.3699 13.0386 12.7043 12.7043M17.2957 17.2957C17.6301 16.9614 17.9012 16.5638 18.0909 16.1213L20.6345 10.1862C20.8567 9.66759 20.3324 9.14325 19.8138 9.3655L13.8787 11.9091C13.4362 12.0988 13.0386 12.3699 12.7043 12.7043M17.2957 17.2957L12.7043 12.7043M27.5 15C27.5 20.1258 24.4148 24.531 20 26.4599"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
